module.exports = __webpack_public_path__ + "img/jingzhuang2.0620ebdb.jpg";